
import React from 'react'
import { compose, bindActionCreators } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import cx from 'classnames'
import * as waiterActions from 'actions/components/waiter'
import * as AppConstants from 'constants/app'

class WaiterNumberPad extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  handleClear = () => {
    this.props.resetWaiterNumberPadValue()
  }

  handleNumberInput= (e) => {
    const prevValue = this.props.waiter.numberPad.value
    let value = ''

    if (prevValue.length >= AppConstants.WAITER_NUMBER_PAD_MAX_LENGTH) {
      value = prevValue.slice(1) + e.target.innerText
    } else {
      value = prevValue + e.target.innerText
    }

    value = String(Number(value))
    this.props.updateWaiterNumberPadValue(value)
  }

  render () {
    const { intl, classes } = this.props
    const { value } = this.props.waiter.numberPad
    const clearText = intl.formatMessage({ id: 'waiter.numberPad.clear' })

    return (
      <div className={classes.gridContainer}>
        <div className={cx(classes.gridItem, classes.clearButton)} onClick={this.handleClear} >
          <div className={classes.value}>{value}</div>
          <div className={classes.clearText}>{clearText}</div>
        </div>
        <div className={cx(classes.gridItem, classes.numberButtonTop)} onClick={e => this.handleNumberInput(e)}>1</div>
        <div className={cx(classes.gridItem, classes.numberButtonTop)} onClick={e => this.handleNumberInput(e)}>2</div>
        <div className={cx(classes.gridItem, classes.numberButtonTop)} onClick={e => this.handleNumberInput(e)}>3</div>
        <div className={cx(classes.gridItem, classes.numberButtonTop)} onClick={e => this.handleNumberInput(e)}>4</div>
        <div className={cx(classes.gridItem, classes.numberButtonTop)} onClick={e => this.handleNumberInput(e)}>5</div>
        <div className={cx(classes.gridItem, classes.numberButtonBottom)} onClick={e => this.handleNumberInput(e)}>6</div>
        <div className={cx(classes.gridItem, classes.numberButtonBottom)} onClick={e => this.handleNumberInput(e)}>7</div>
        <div className={cx(classes.gridItem, classes.numberButtonBottom)} onClick={e => this.handleNumberInput(e)}>8</div>
        <div className={cx(classes.gridItem, classes.numberButtonBottom)} onClick={e => this.handleNumberInput(e)}>9</div>
        <div className={cx(classes.gridItem, classes.numberButtonBottom)} onClick={e => this.handleNumberInput(e)}>0</div>
      </div>
    )
  }
}

const styles = {
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(6, 1fr)',
    gridTemplateRows: 'repeat(2, 1fr)',
    backgroundColor: '#EFDA8E',
    padding: 8,
  },
  gridItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 24,
    fontFamily: 'Roboto',
    color: '#542E28',
    padding: 16,
    boxSizing: 'border-box',
    '&:active': {
      backgroundColor: '#ecd378',
    },
  },
  numberButtonTop: {
    borderLeft: '2px solid #E2C663',
    borderBottom: '2px solid #E2c663',
  },
  numberButtonBottom: {
    borderLeft: '2px solid #E2C663',
  },
  clearButton: {
    flexDirection: 'column',
    gridRow: '1 / span 2',
    minWidth: 72,
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  value: {
    fontSize: 32,
    flex: 1,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  clearText: {
    fontSize: 18,
  },
}

const mapStateToProps = (state) => {
  return {
    waiter: state.waiter,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators(waiterActions, dispatch),
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(WaiterNumberPad)



// WEBPACK FOOTER //
// ./src/components/WaiterNumberPad.jsx